import type { FilterDataRange } from '@/app/common/filters/core/filtersTypes.ts';

const STATIC_RANGE_ROUND_TO = 50;

const getRoundTo = (min: number, max: number) => {
  if (max - min <= 50) return 1;
  if (max - min <= 500) return 10;
  return STATIC_RANGE_ROUND_TO;
};

// A histogram needs one non-zero bucket to be worth drawing; without one the range is static.
export const hasDiagram = (
  dynamicValues: FilterDataRange['dynamicValues']
): dynamicValues is NonNullable<FilterDataRange['dynamicValues']> =>
  !!dynamicValues?.diagram?.length && dynamicValues.diagram.some((num) => num !== 0);

// The granularity the slider moves by; multiples of it stay round-trippable in a converted unit.
export const getRangeRoundTo = ({ dynamicValues }: FilterDataRange) =>
  hasDiagram(dynamicValues) ? getRoundTo(dynamicValues.from, dynamicValues.to) : STATIC_RANGE_ROUND_TO;

export const getRangeBounds = (data: FilterDataRange) =>
  hasDiagram(data.dynamicValues)
    ? { from: data.dynamicValues.from, to: data.dynamicValues.to }
    : { from: 0, to: data.maxValue };
